/* eslint-disable react/prop-types */
import React from "react";
import ErrorPage from "../../pages/404";

const ErrorBoundary = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: {} };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: { name: error.name, message: error.message || errorInfo },
    });
  }

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <ErrorPage
          errorCode={error?.name}
          rawError="الرجاء المحاولة في وقت لاحق"
        />
      );
    }

    return children;
  }
};

export default ErrorBoundary;
